/* Frantoio di Assisi — comportamenti delle sezioni contenuto (FAQ, spedizioni, contatti, cultivar).
   Complementare a theme.js; si re-inizializza con gli eventi dell'editor del tema. */
(function () {
  'use strict';
  if (window.FAContent) return;
  window.FAContent = true;

  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function norm(t) { return (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }

  /* FAQ: ricerca testuale combinata con i chip di theme.js (data-fa-filter) */
  function initFaq(root) {
    $all('[data-fa-faq]', root).forEach(function (el) {
      if (el._faq) return; el._faq = true;
      var input = el.querySelector('[data-fa-faq-search]'), count = el.querySelector('[data-fa-faq-count]');
      var items = $all('[data-fa-filter-item]', el), btns = $all('[data-fa-filter-btn]', el);
      function apply() {
        var q = norm(input ? input.value.trim() : ''), active = 'all', shown = 0;
        btns.forEach(function (b) { if (b.getAttribute('aria-pressed') === 'true') active = b.dataset.faFilterBtn; });
        items.forEach(function (it) {
          var okCat = active === 'all' || (' ' + it.dataset.faFilterItem + ' ').indexOf(' ' + active + ' ') > -1;
          var okQ = !q || norm(it.textContent).indexOf(q) > -1;
          it.hidden = !(okCat && okQ); if (!it.hidden) shown++;
          if (q && okCat && okQ) it.open = true;
        });
        if (count) count.textContent = shown === 0 ? count.dataset.none : shown === 1 ? count.dataset.one : (count.dataset.many || '').replace('[n]', shown);
      }
      if (input) input.addEventListener('input', apply);
      // theme.js imposta aria-pressed al click: riapplichiamo subito dopo
      btns.forEach(function (b) { b.addEventListener('click', function () { setTimeout(apply, 0); }); });
    });
  }

  /* Tabella spedizioni: cambia i tre riquadri in base al paese */
  function initShip(root) {
    $all('[data-fa-ship]', root).forEach(function (el) {
      var sel = el.querySelector('[data-fa-ship-select]'); if (!sel || sel._ship) return; sel._ship = true;
      var out = { days: el.querySelector('[data-fa-ship-days]'), cost: el.querySelector('[data-fa-ship-cost]'), free: el.querySelector('[data-fa-ship-free]'), note: el.querySelector('[data-fa-ship-note]') };
      sel.addEventListener('change', function () {
        var o = sel.options[sel.selectedIndex]; if (!o) return;
        Object.keys(out).forEach(function (k) { if (out[k]) out[k].textContent = o.dataset[k] || ''; });
      });
    });
  }

  /* Modulo contatti: suggerimento del messaggio e campo aziende secondo il motivo */
  function initContact(root) {
    $all('[data-fa-contact-body]', root).forEach(function (body) {
      var form = body.closest('form'); if (!form || form._contact) return; form._contact = true;
      var company = form.querySelector('[data-fa-contact-company]');
      function apply() {
        var r = form.querySelector('input[name="contact[Motivo]"]:checked'); if (!r) return;
        body.placeholder = r.dataset.placeholder || '';
        if (company) company.hidden = r.dataset.company !== 'true';
      }
      $all('input[name="contact[Motivo]"]', form).forEach(function (r) { r.addEventListener('change', apply); });
      apply();
    });
  }

  /* Contatore "1 di 6" e nomi precedente/successivo nelle schede (es. cultivar) */
  function initTabCounter(root) {
    $all('[data-fa-tab-counter-wrap]', root).forEach(function (el) {
      if (el._cnt) return; el._cnt = true;
      var tabs = $all('[role="tab"]', el), counter = el.querySelector('[data-fa-tab-counter]'),
          prev = el.querySelector('[data-fa-tab-prev-name]'), next = el.querySelector('[data-fa-tab-next-name]');
      if (!tabs.length) return;
      function update() {
        var i = tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; }); if (i < 0) i = 0;
        var n = tabs.length;
        if (counter) counter.textContent = (counter.dataset.template || '[i] / [n]').replace('[i]', i + 1).replace('[n]', n);
        if (prev) prev.textContent = tabs[(i - 1 + n) % n].dataset.name || '';
        if (next) next.textContent = tabs[(i + 1) % n].dataset.name || '';
      }
      if ('MutationObserver' in window) {
        var mo = new MutationObserver(update);
        tabs.forEach(function (t) { mo.observe(t, { attributes: true, attributeFilter: ['aria-selected'] }); });
      }
      update();
    });
  }

  function init(root) { initFaq(root); initShip(root); initContact(root); initTabCounter(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* Editor del tema: selezionando un blocco lo si rende visibile */
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (el.matches('[role="tab"]')) el.click();
    if (el.tagName === 'DETAILS') el.open = true;
    if (el.tagName === 'OPTION') { var s = el.closest('select'); if (s) { s.value = el.value; s.dispatchEvent(new Event('change')); } }
    if (el.classList.contains('fa-contact__reason')) { var r = el.querySelector('input'); if (r) { r.checked = true; r.dispatchEvent(new Event('change')); } }
  });
})();
